module.exports = __webpack_public_path__ + "img/a-propos.da8f0d12.jpg";